import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import moment from "moment";

import logoWhite from "../assets/img/logo-white.svg";
import { ReactComponent as IconUser } from "../assets/img/user2.svg";
import download from "../assets/img/download.png";
import {
  gup,
  checkDeviceAndBrowser,
  decodeUrlString,
  getApiUrl,
} from "../utils/utils";

import { ReactComponent as Archive } from "../assets/img/archive.svg";
import { ReactComponent as Excel } from "../assets/img/excel.svg";
import { ReactComponent as Word } from "../assets/img/word.svg";
import { ReactComponent as Code } from "../assets/img/code.svg";
import { ReactComponent as Audio } from "../assets/img/audio.svg";
import { ReactComponent as Pdf } from "../assets/img/pdf.svg";
import { ReactComponent as Image } from "../assets/img/image.svg";
import { ReactComponent as Video } from "../assets/img/video.svg";
import { ReactComponent as Ppt } from "../assets/img/powerpoint.svg";
import { ReactComponent as File2 } from "../assets/img/file2.svg";
import { ReactComponent as Tableur } from "../assets/img/tableur.svg";
import { ReactComponent as Text } from "../assets/img/text.svg";
import { ReactComponent as Empty } from "../assets/img/empty.svg";

import favicon from "../assets/img/favicon.png";
import space from "../assets/img/space.jpg";
import Footer from "./Footer";
import RightSide from "./RightSide";
import FileNotFound from "./FileNotFound";
import BadBrowser from "./BadBrowser";
import WrongToken from "./WrongToken";
import OpenDeposit from "./OpenDeposit";
import SendDeposit from "../containers/SendDeposit";

import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition,
} from "react-toasts";
import ProtectedDeposit from "./ProtectedDeposit";
import Loader from "./Loader";

let BASE_URL = getApiUrl();

class ConsultDeposit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      badBrowser: false,
      boxHash1: gup("hash1"),
      boxHash2: gup("hash2"),
      creationDate: "",
      description: "",
      errorMessage: null,
      files: [],
      id: "",
      isAvailable: null,
      isLoading: false,
      isv2: false,
      name: "",
      search: "",
      statusCode: null,
      token: "",
      tokenUrl: gup("t"),
      userToken: "",
      userHash1: gup("uh1"),
      userHash2: gup("uh2"),
      depositId: gup("id"),
      users: [],
      whitemarkBackground: "",
      whitemarkBtnColor: "",
      whitemarkFavicon: "",
      whitemarkLogo: "",
      whitemarkMaxSize: "",
      whitemarkTitle: "",
      isProtected: gup("id") && gup("name"),
      protectedDepositInfo: {},
      depositBoxName: decodeUrlString(gup("name")),
      mainMenuBtnActiveId: "consult",
      selectedFilesId: [],
      openToken: "",
      openDepositName: "",
      creatorName: "",
      openDepositDate: "",
      openDepositNewLink: false,
      externalUsers: [],
      userEmail: "",
      userFname: "",
      userLname: "",
    };
  }

  componentDidMount = async () => {
    //this.props.actions.resetAllProps();
    const isBadBrowser = await checkDeviceAndBrowser().then(res => !res);
    this.setState({ badBrowser: isBadBrowser });
    await this.getWhitemark();
    if (!this.state.isProtected) {
      await this.getInfo();
    }
    if (this.state.protectedDepositInfo.data?.errorMessage) {
      this.setState({
        statusCode: 403,
      });
    }
  };

  componentWillMount = async () => {
    window.addEventListener("DOMContentLoaded", () => {
      localStorage.removeItem("password");
    });
  };

  // Check if there is hash, deposit, uh and id in url
  checkIfAllInfo = () => {
    const informations = [
      this.state.tokenUrl,
      this.state.userHash1,
      this.state.userHash2,
      this.state.depositId,
      this.state.boxHash1,
      this.state.boxHash2,
    ];
    return informations.includes(null);
  };

  getWhitemark = async () => {
    const openToken = gup("openToken");
    let boxHash1 = this.state.boxHash1;
    let boxHash2 = this.state.boxHash2;

    if (openToken && (!boxHash1 || !boxHash2)) {
      const json = localStorage.getItem(`tokenData-${openToken}`);
      if (json) {
        let data = null;
        try {
          data = JSON.parse(json);

          const expirationDate = new Date(data?.expirationDate);
          const now = new Date();

          if (data && now < expirationDate) {
            boxHash1 = data.depositBox?.hash1;
            boxHash2 = data.depositBox?.hash2;

            this.setState({
              userHash1: data.userHash1,
              userHash2: data.userHash2,
              userToken: data.token,
              boxHash1,
              boxHash2,
            });
          }
        } catch {
          localStorage.removeItem(`tokenData-${openToken}`);
        }
      }
    }

    let queryParams = "";
    if (boxHash1 && boxHash2) {
      queryParams = `hash1=${boxHash1}&hash2=${boxHash2}`;
    } else {
      queryParams = `openToken=${openToken}`;
    }

    await fetch(
      `${getApiUrl()}/api/external/depositboxes/whitemark?${queryParams}`,
    )
      .then(res => {
        return res.json();
      })
      .then(res => {
        this.setState({
          whitemarkFavicon: res["whitemarkFavicon"]
            ? "data:image/svg+xml;base64," + res["whitemarkFavicon"]
            : favicon,
          whitemarkTitle: res["whitemarkTitle"]
            ? res["whitemarkTitle"]
            : "LockSelf Deposit Box",
          whitemarkLogo: res["whitemarkLogo"]
            ? "data:image/svg+xml;base64," + res["whitemarkLogo"]
            : logoWhite,
          whitemarkBackground: res["whitemarkBackground"]
            ? "data:image/png;base64," + res["whitemarkBackground"]
            : space,
          whitemarkBtnColor: res["whitemarkBtnColor"]
            ? "#" + res["whitemarkBtnColor"]
            : "#f47532",
          whitemarkMaxSize: res["whitemarkMaxUpload"] || 100,
        });
      })
      .catch(error => {
        console.log("ERROR1 = ", error);
      });
  };

  getInfo = async () => {
    const url = window.location.href;
    const json = localStorage.getItem(`tokenData-${gup("openToken")}`);
    const data = JSON.parse(json);

    if (gup("openToken") && !gup("token")) {
      this.setState({
        openToken: gup("openToken"),
      });
      await fetch(
        `${BASE_URL}/api/external/depositboxes/open?openToken=${this.state.openToken}`,
      )
        .then(res => {
          this.setState({
            statusCode: res.status,
          });
          return res.json();
        })
        .then(res => {
          if (!res.message) {
            this.setState({
              openDepositName: res.depositBoxName,
              creatorName: res.creatorName,
              openDepositDate: res.depositBoxCreationDate,
            });
          }
        });
      return;
    } else if (gup("token") && gup("openToken")) {
      const expirationDate = new Date(data?.expirationDate);
      const now = new Date();
      if (data && now < expirationDate) {
        this.setState({
          userHash1: data.userHash1,
          userHash2: data.userHash2,
          userToken: data.token,
          boxHash1: data.depositBox?.hash1,
          boxHash2: data.depositBox?.hash2,
        });
      } else {
        const token = gup("token", url);
        await fetch(
          `${BASE_URL}/api/external/depositboxes/open/token/validate?token=${token}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              token: token,
            }),
          },
        )
          .then(res => {
            this.setState({
              statusCode: res.status,
            });
            return res.json();
          })
          .then(res => {
            if (!res.message) {
              this.setState({
                userHash1: res.userHash1,
                userHash2: res.userHash2,
                userToken: res.token,
                boxHash1: res.depositBox?.hash1,
                boxHash2: res.depositBox?.hash2,
                creationDate: res.depositBox.creationDate,
                description: res.depositBox.description,
                files: res.depositBox.files,
                id: res.depositBox.id,
                name: res.depositBox.name,
                users: res.depositBox.users,
                externalUsers: res.depositBox.externalUsers,
              });

              localStorage.setItem(
                `tokenData-${gup("openToken")}`,
                JSON.stringify(res),
              );
            } else {
              this.setState({
                openDepositNewLink: true,
                openToken: gup("openToken"),
              });
            }
          });
        return;
      }
    }

    await fetch(
      `${BASE_URL}/api/external/depositboxes/info?hash1=${
        this.state.boxHash1
      }&hash2=${this.state.boxHash2}&uh1=${this.state.userHash1}&uh2=${
        this.state.userHash2
      }&token=${gup("openToken") ? this.state.userToken : this.state.tokenUrl}`,
    )
      .then(res => {
        this.setState({
          statusCode: res.status,
        });
        return res.json();
      })
      .then(res => {
        if (res.errorMessage) {
          this.setState({
            creationDate: res.box.creationDate,
            description: res.box.description,
            files: res.box.files,
            id: res.box.id,
            isAvailable: false,
            name: res.box.name,
            token: res.box.token,
            users: res.box.externalUsers,
            statusCode: 403,
          });
        } else {
          this.setState({
            creationDate: res.creationDate,
            description: res.description,
            files: res.files,
            id: res.id,
            isAvailable: true,
            name: res.name,
            token: res.token,
            users: res.externalUsers,
          });

          const sortedFiles = [...res.files].sort((a, b) =>
            a.creationDate < b.creationDate ? 1 : -1,
          );
          this.setState({
            files: sortedFiles,
          });
        }

        this.setState(prevState => ({
          files: prevState.files.map(file => ({ ...file, isLoading: prevState.isLoading })),
        }));

      })
      .catch(error => {
        console.log("ERROR2 = ", error);
        if (data) {
          localStorage.removeItem(`tokenData-${gup("openToken")}`);
        }
      });
  };

  sortBy = (e, listToSort) => {
    this.props.actions.setValueSelect(e.target.value);
    if (e.target.value === "plusRecent") {
      listToSort.sort((a, b) => (a.creationDate < b.creationDate ? 1 : -1));
    } else if (e.target.value === "moinsRecent") {
      listToSort.sort((a, b) => (a.creationDate > b.creationDate ? 1 : -1));
    } else if (e.target.value === "plusLourd") {
      listToSort.sort((a, b) => (a.realSize < b.realSize ? 1 : -1));
    } else {
      listToSort.sort((a, b) => (a.realSize > b.realSize ? 1 : -1));
    }
    this.setState({
      files: listToSort,
    });
  };

  updateSearch = e => {
    this.setState({
      search: e.target.value.substr(0),
    });
  };

  updateListFiles = listFiles => {
    const sorted = [...listFiles].sort((a, b) =>
      a.creationDate < b.creationDate ? 1 : -1,
    );
    this.setState({ files: sorted });
  };

  displaySendBox = () => {
    this.setState({
      mainMenuBtnActiveId: "send",
    });
    this.props.actions.resetAllProps();
    this.props.actions.readyToSend();
  };

  displayConsultBox = () => {
    this.setState({
      mainMenuBtnActiveId: "consult",
    });
    this.props.actions.setReadyToSend(false);
    //this.props.actions.resetAllProps();
  };


  download = async (multiple = false) => {
    const that = this;
    that.setState({ isLoading: true });

    function handleComplete() {
      that.setState({ isLoading: false });
    }

    // Fonction pour télécharger un fichier unique
    const downloadSingleFile = async fileId => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          method: "downloadDbFile",
          depositFileHash1: that.state.boxHash1,
          depositFileHash2: that.state.boxHash2,
          depositFileUh1: that.state.userHash1,
          depositFileUh2: that.state.userHash2,
          token: gup("openToken") ? that.state.userToken : that.state.tokenUrl,
          depositFileId: fileId,
        }),
      };

      if (that.state.isProtected) {
        const requestBody = JSON.parse(requestOptions.body);
        requestBody.password = localStorage.getItem("password");
        requestOptions.body = JSON.stringify(requestBody);
      }

      try {
        const response = await fetch(
          `${BASE_URL}/api/download/generate/token`,
          requestOptions,
        );
        const responseStatus = response.ok;

        if (!responseStatus)
          throw new Error(
            "Erreur lors de la génération du lien de téléchargement",
          );

        const result = await response.json();

        // Créer un lien pour télécharger directement le fichier
        const link = document.createElement("a");
        link.href = result.link;
        link.download = ""; // Le nom du fichier sera défini par le serveur
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error(
          `Erreur lors du téléchargement du fichier ${fileId} :`,
          error,
        );
      }
    };

    // Téléchargement multiple ou unique
    try {
      if (multiple) {
        // Télécharger chaque fichier séquentiellement avec un délai
        for (const selectedFile of this.state.selectedFilesId) {
          await downloadSingleFile(selectedFile);
          await new Promise(resolve => setTimeout(resolve, 500)); // Délai de 500 ms entre les téléchargements
        }
      } else {
        // Télécharger un seul fichier
        const file = this.state.files?.find(
          file => file?.id === this.state.selectedFilesId?.[0],
        );
        if (file) {
          await downloadSingleFile(file.id);
        }
      }
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
    } finally {
      handleComplete();
    }
  };

  checkToaster = toaster => {
    if (toaster.length !== 0) {
      if (toaster.toasterColor === "error") {
        ToastsStore.error(toaster.toasterText, 5000);
      } else {
        ToastsStore.success(toaster.toasterText, 5000);
      }
      this.props.actions.removeToaster();
    }
  };

  displayMVIcons = (darkMode = false, list = [], supName = "", justMVP) => {
    function getFileExtension(filename) {
      // console.log(filename, "filename")

      return /[.]/.exec(filename)
        ? /[^.]+$/.exec(filename)?.[0].toLowerCase()
        : null;
    }

    function checkFileType(
      filename,
      isIcon = false,
      DM = false,
      directExt = false,
    ) {
      let ext = directExt ? filename : getFileExtension(filename);
      switch (ext) {
        case "zip":
        case "rar":
        case "7z":
        case "tar":
        case "gz":
        case "icon-file-archive":
          return isIcon ? <Archive /> : "icon-file-archive";
        case "xlsx":
        case "xls":
        case "xlsm":
        case "xlsb":
        case "xltx":
        case "icon-file-excel":
          return isIcon ? <Excel /> : "icon-file-excel";
        case "xml":
        case "csv":
        case "numbers":
        case "icon-file-tableur":
          return isIcon ? <Tableur /> : "icon-file-tableur";
        case "doc":
        case "docx":
        case "icon-file-word":
          return isIcon ? <Word /> : "icon-file-word";
        case "odt":
        case "txt":
        case "pages":
        case "icon-file-text":
          return isIcon ? <Text /> : "icon-file-text";
        case "js":
        case "php":
        case "c":
        case "py":
        case "rb":
        case "html":
        case "go":
        case "css":
        case "scss":
        case "config":
        case "icon-file-code":
          return isIcon ? <Code /> : "icon-file-code";
        case "riff":
        case "wav":
        case "bwf":
        case "ogg":
        case "aiff":
        case "caf":
        case "raw":
        case "mp3":
        case "wma":
        case "icon-file-audio":
          return isIcon ? <Audio /> : "icon-file-audio";
        case "pdf":
        case "icon-file-pdf":
          return isIcon ? <Pdf /> : "icon-file-pdf";
        case "bmp":
        case "tiff":
        case "gif":
        case "jpeg":
        case "png":
        case "jpg":
        case "ico":
        case "icon-file-image-o":
          return isIcon ? <Image /> : "icon-file-image-o";
        case "avi":
        case "mov":
        case "mpg":
        case "mp4":
        case "mkv":
        case "divx":
        case "icon-file-video":
          return isIcon ? <Video /> : "icon-file-video";
        case "pptx":
        case "pptm":
        case "ppt":
        case "key":
        case "icon-file-powerpoint":
          return isIcon ? <Ppt /> : "icon-file-powerpoint";
        case "empty":
        case 0:
        case "icon-file-empty":
          return isIcon ? <Empty /> : "icon-file-empty";
        default:
          return isIcon ? <File2 /> : "icon-file";
      }
    }

    let arr = [];
    //console.log(supName)

    if (supName?.length) arr.push(checkFileType(supName));

    if (list.length >= 1) {
      list.map(item => {
        arr.push(checkFileType(item.name));
      });
    }

    let counts = [];
    let exts = [];

    arr.map(item => {
      if (exts.includes(item)) return;
      else return exts.push(item);
    });

    exts.map(item => {
      counts.push({
        ext: item,
        count: arr.filter(x => x === item).length,
      });
    });

    let sortedArr = counts.sort((a, b) =>
      a.count > b.count ? -1 : b.count > a.count ? 1 : 0,
    );

    if (justMVP) {
      if (sortedArr.length >= 1)
        return checkFileType(sortedArr[0].ext, true, false, true);
      else return checkFileType("empty", true, false, true);
    } else {
      if (sortedArr.length === 1) {
        return checkFileType(sortedArr[0].ext, true, false, true);
      } else if (sortedArr.length === 2) {
        return (
          <div className="icon-container">
            {checkFileType(sortedArr[0].ext, true, false, true)}
            {checkFileType(sortedArr[1].ext, true, false, true)}
          </div>
        );
      } else if (sortedArr.length > 2) {
        return (
          <div className="icon-container">
            {checkFileType(sortedArr[0].ext, true, false, true)}
            {checkFileType(sortedArr[1].ext, true, false, true)}
            <b className="hasMore">{sortedArr.length > 2 ? "+" : ""}</b>
          </div>
        );
      } else {
        return (
          <div className="icon-container">
            {checkFileType("empty", true, false, true)}
          </div>
        );
      }
    }
  };

  selectAllFiles = () => {
    this.setState({
      selectedFilesId: this.state?.files?.map(file => file?.id),
    });
  };

  cancelFileSelection = () => {
    this.setState({
      selectedFilesId: [],
    });
  };

  selectTab = (readyToSend, t) => {
    let filteredFiles = this.state.files?.filter(file => {
      return (
        file?.name
          ?.toLowerCase()
          ?.includes(this?.state?.search?.toLowerCase()) ||
        file?.uploader
          ?.toLowerCase()
          ?.includes(this?.state?.search?.toLowerCase()) ||
        file?.creationDate?.includes(this?.state?.search)
      );
    });

    if (!readyToSend) {
      return (
        <div className="Card fileBox">
          <div className="headerBox">
            <div className="inputContainer">
              <input
                type="text"
                name="rechercher"
                placeholder={t("depositBox.search")}
                value={this.state.search}
                onChange={e => this.updateSearch(e)}
              />
            </div>

            {this.sortFiles(this.state.files, t)}
          </div>

          <div className="filesListActions">
            {this.state.files?.length > 0 &&
              this.state?.selectedFilesId?.length <
                this.state.files?.length && (
                <button
                  className="actionBtn"
                  onClick={() => this.selectAllFiles()}
                >
                  {t("depositBox.selectAll")}
                </button>
              )}
            {this.state.files?.length > 0 &&
              this.state?.selectedFilesId?.length > 0 && (
                <button
                  className="actionBtn"
                  onClick={() => this.cancelFileSelection()}
                >
                  {t("depositBox.cancelSelection")}
                </button>
              )}
          </div>

          <div className="bodyBoxContainer">
            <div id="depositBox" className="bodyBox">
              {this.listFiles(filteredFiles, t)}
            </div>
          </div>

          {this.state.files?.length > 0 && (
            <button
              className={`greyBtn downloadFiles${
                this.state.selectedFilesId?.length > 0 ? " isActive" : ""
              }`}
              onClick={() => {
                if (this.state.selectedFilesId?.length > 0) {
                  if (this.state.selectedFilesId?.length === 1) {
                    const selectedFile = this.state.files?.find(
                      file => file?.id === this.state.selectedFilesId?.[0],
                    );

                    if (!!selectedFile) {
                      this.download();
                    }
                  } else if (this.state.selectedFilesId?.length > 1) {
                    this.download(true);
                  }
                }
              }}
            >
              {t("depositBox.download")}
              {this.state?.selectedFilesId?.length > 0 &&
                ` (${this.state?.selectedFilesId?.length})`}
            </button>
          )}
        </div>
      );
    } else {
      return (
        <SendDeposit
          baseUrl={BASE_URL}
          boxHash1={this.state.boxHash1}
          boxHash2={this.state.boxHash2}
          displayConsultBox={this.displayConsultBox}
          id={this.state.id}
          loggedUser={this.state.users[0]}
          tokenUrl={this.state.tokenUrl}
          token={this.state.token}
          userToken={this.state.userToken}
          updateListFiles={this.updateListFiles}
          userHash1={this.state.userHash1}
          userHash2={this.state.userHash2}
          users={this.state.users}
          whitemarkMaxSize={this.state.whitemarkMaxSize}
          isProtected={this.state.isProtected}
        />
      );
    }
  };

  listFiles = (filteredFiles, t) => {
    if (filteredFiles?.length === 0) {
      return (
        <div id="empty" className="empty">
          <img src={download} alt="Dossier" />
          <span className="grey_pill">{t("depositBox.noneFile")}</span>
          <span>{t("depositBox.pressSend")}</span>
        </div>
      );
    } else {
      if (this.state.search.length !== 0) {
        return (
          <div className="listFiles">
            {filteredFiles.map(elem => {
              return (
                <div key={elem.id} className="element">
                  {this.elemFile(elem, this.state.isv2, t)}
                </div>
              );
            })}
          </div>
        );
      } else {
        return (
          <div className="listFiles">
            {this.state.files?.map(elem => {
              return (
                <div key={elem.id} className="element">
                  {this.elemFile(elem, this.state.isv2, t)}
                </div>
              );
            })}
          </div>
        );
      }
    }
  };

  elemFile = (elem, isv2, t) => {
    return (
      <div
        className="body"
        onClick={() => {
          if (this.state?.selectedFilesId?.includes(elem?.id)) {
            this.setState({
              selectedFilesId: this.state.selectedFilesId?.filter(
                id => id !== elem?.id,
              ),
            });
          } else {
            this.setState({
              selectedFilesId: [...this.state.selectedFilesId, elem?.id],
            });
          }
        }}
      >
        <div
          className={`checkBox ${
            this.state?.selectedFilesId?.includes(elem?.id) ? "selected" : ""
          }`}
        />
        <div className="doc">{this.displayMVIcons(false, [elem])}</div>

        <div className="descAndDl">
          <div className="description">
            <div className="titleContent">
              <div className="titleContainer">
                <h5
                  data-toggle="tooltip"
                  data-placement="top"
                  title={elem.name}
                >
                  {elem.name}
                </h5>
              </div>
              <span className="fileSize">{elem.size}</span>
            </div>
            <p
              data-toggle="tooltip"
              data-placement="top"
              title={elem.description}
            >
              {elem.description}
            </p>
            {elem.isLoading && this.state.isLoading && isv2 !== false && (
              <span>{t("depositBox.downloadProgress")}</span>
            )}
          </div>
        </div>
        {this.authorFile(elem, t)}
      </div>
    );
  };

  authorFile = (elem, t) => {
    return (
      <div className="author">
        <div className="authorContent">
          <span
            className="date"
            title={`${t("depositBox.depositOn")} ${moment(
              elem.creationDate,
            ).format("LL")} ${t("general.at")} ${moment(
              elem.creationDate,
            ).format("HH:mm")} ${t("depositBox.by")} ${elem.uploader}`}
          >
            {t("depositBox.depositOn")}&nbsp;
            {moment(elem.creationDate).format("LL")}
            <br />
            {t("general.at")}&nbsp;
            {moment(elem.creationDate).format("HH:mm")}
            &nbsp;{t("depositBox.by")}
            {elem.uploader}
          </span>
        </div>
      </div>
    );
  };

  sortFiles = (listFiles, t) => {
    return (
      <div className="filtres">
        {t("depositBox.sortBy")}
        <select
          name="filterBy"
          value={this.props.valueSelect}
          onChange={e => this.sortBy(e, listFiles)}
        >
          <option value="plusRecent">{t("depositBox.latest")}</option>
          <option value="moinsRecent">{t("depositBox.oldest")}</option>
          <option value="plusLourd">{t("depositBox.heavy")}</option>
          <option value="moinsLourd">{t("depositBox.light")}</option>
        </select>
      </div>
    );
  };

  loggedUser = () => {
    return this.state.users.filter(
      user =>
        user.uh1 === this.state.userHash1 && user.uh2 === this.state.userHash2,
    );
  };

  headerCard = t => {
    return (
      <div className="dHead">
        <div className="leftBox">
          <h1 className="title" title={this.state.name}>
            <span className="titleLabel">{t("depositBox.name")} :&nbsp;</span>
            {this.state.name}
          </h1>
          <div className="sender">
            <IconUser className="icon" />
            <span className="senderName">
              {t("depositBox.by")}&nbsp;
              {this.state.externalUsers && this.state.externalUsers.length !== 0
                ? this.state.externalUsers[0]?.ownerFirstName +
                  " " +
                  this.state.externalUsers[0]?.ownerLastName
                : this.state.users && this.state.users.length !== 0
                ? this.state.users[0]?.ownerFirstName +
                  " " +
                  this.state.users[0]?.ownerLastName
                : null}
            </span>
          </div>
          {this.state.description !== "" && (
            <div className="bddDescriptionContainer">
              <p className="bddDescription" title={this.state.description}>
                {this.state.description}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  mainMenu = t => {
    return (
      <div className="mainMenu">
        <div className="menuCache"></div>
        <div
          className={`mainMenuBtnContainer${
            this.state.mainMenuBtnActiveId === "consult" ? " isActive" : ""
          }`}
          onClick={e => this.displayConsultBox()}
        >
          <button id="consultBtn" className="mainMenuBtn">
            {t("depositBox.consult")}
          </button>
        </div>
        <div
          className={`mainMenuBtnContainer${
            this.state.mainMenuBtnActiveId === "send" ? " isActive" : ""
          }`}
          onClick={e => this.displaySendBox()}
        >
          <button id="sendBtn" className="mainMenuBtn">
            {t("depositBox.send")}{" "}
          </button>
        </div>
      </div>
    );
  };

  handleAuthenticationChange = (data, error) => {
    this.setState({
      creationDate: data.creationDate,
      description: data.description,
      users: data.externalUsers,
      files: data.files,
      id: data.id,
      name: data.name,
      token: data.token,
      isAvailable: false,
      protectedDepositInfo: data,
      errorMessage: error,
      statusCode: data.code,
    });
  };

  render() {
    const {
      whitemarkBackground,
      whitemarkBtnColor,
      whitemarkFavicon,
      whitemarkLogo,
      whitemarkTitle,
    } = this.state;
    const { toaster, t } = this.props;

    if (this.state.badBrowser) {
      return (
        <BadBrowser
          whitemarkBackground={whitemarkBackground}
          whitemarkBtnColor={whitemarkBtnColor}
          whitemarkFavicon={whitemarkFavicon}
          whitemarkLogo={whitemarkLogo}
          whitemarkTitle={whitemarkTitle}
        />
      );
    }
    // Check if status code is 404 OR if the page is protected, if there is all necessary info in url, otherwise return not found
    if (
      404 === this.state.statusCode ||
      (this.state.isProtected && this.checkIfAllInfo())
    ) {
      return (
        <FileNotFound
          whitemarkBackground={whitemarkBackground}
          whitemarkBtnColor={whitemarkBtnColor}
          whitemarkFavicon={whitemarkFavicon}
          whitemarkLogo={whitemarkLogo}
          whitemarkTitle={whitemarkTitle}
        />
      );
    }
    if (403 === this.state.statusCode || this.state.errorMessage) {
      return (
        <WrongToken
          boxCreationDate={this.state.creationDate}
          boxDescription={this.state.description}
          boxHash1={this.state.boxHash1}
          boxHash2={this.state.boxHash2}
          boxName={this.state.name}
          boxToken={this.state.token}
          emailsList={this.state.users}
          userEmail={this.state.userEmail}
          userFname={this.state.userFname}
          userLname={this.state.userLname}
          userHash1={this.state.userHash1}
          userHash2={this.state.userHash2}
          whitemarkBackground={whitemarkBackground}
          whitemarkBtnColor={whitemarkBtnColor}
          whitemarkFavicon={whitemarkFavicon}
          whitemarkLogo={whitemarkLogo}
          whitemarkTitle={whitemarkTitle}
          openDepositNewLink={this.state.openDepositNewLink}
        />
      );
    }

    // for open deposit
    if (gup("openToken") && !gup("token")) {
      return (
        <OpenDeposit
          toaster={toaster}
          openToken={this.state.openToken}
          openDepositName={this.state.openDepositName}
          creatorName={this.state.creatorName}
          openDepositDate={this.state.openDepositDate}
          whitemarkBackground={whitemarkBackground}
          whitemarkBtnColor={whitemarkBtnColor}
          whitemarkFavicon={whitemarkFavicon}
          whitemarkLogo={whitemarkLogo}
          whitemarkTitle={whitemarkTitle}
        />
      );
    }
    // If the deposit box is protected, show protected view
    if (
      this.state.isProtected &&
      Object.keys(this.state.protectedDepositInfo).length === 0
    ) {
      return (
        <ProtectedDeposit
          getProtectedDepositInfo={this.handleAuthenticationChange}
          whitemarkBackground={whitemarkBackground}
          whitemarkBtnColor={whitemarkBtnColor}
          whitemarkFavicon={whitemarkFavicon}
          whitemarkLogo={whitemarkLogo}
          whitemarkTitle={whitemarkTitle}
          depositBoxName={this.state.depositBoxName}
        />
      );
    }
    return (
      <div className="main">
        {this.checkToaster(toaster)}
        <ToastsContainer
          position={ToastsContainerPosition.TOP_RIGHT}
          store={ToastsStore}
          lightBackground
        />
        <Helmet>
          <title>{whitemarkTitle}</title>
          {<link rel="shortcut icon" href={whitemarkFavicon} />}
          <style type="text/css">
            {`
                        :root {
                            --wm-button-color: ${whitemarkBtnColor};
                        }

                        .main {
                            background:url(${whitemarkBackground});
                            background-size:cover;
                            background-attachment: fixed;
                        }

                        .main>div.darker{
                            background-color: rgba(32,32,48,0.7);
                            min-height: 100vh;
                        }

                        button.orangeBtn {
                            background-color: ${whitemarkBtnColor};
                        }

                        .logo {
                            background-image: url(${whitemarkLogo});
                        }

                        #downloadImg {
                            background-image: url(${download});
                        }
                    `}
          </style>
        </Helmet>
        <div className="noDark">
          <div className="container-fluid mainDeposit">
            {this.state.isLoading && <Loader />}
            <div className="row rowDepot">
              <div className="col-12 logoDiv">
                <div className="logo"></div>
              </div>
              <div className="containerDeposit">
                <div className="containerDepositContainer">
                  {this.headerCard(t)}
                  <div className="contentContainerData">
                    {this.mainMenu(t)}
                    {this.selectTab(this.props.readyToSend, t)}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
            <RightSide depositAvailable={this.state.isAvailable} />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ConsultDeposit);
